<div class="step-placeholder">
  <p class="step-placeholder-title">{{ titleKey | translate }}</p>
  <p class="step-placeholder-message">
    {{ 'SERVICE_PLAN.PLACEHOLDER.NOT_YET_BUILT' | translate }}
  </p>
</div>
